import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Button from "components/CustomButtons/Button.js";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { NavLink } from "react-router-dom";
import Warning from "@mui/icons-material/Warning"
import { NumericFormat } from 'react-number-format';

const Card = styled.div`
  border: "0";
  margin-bottom: 0px;
  margin-top: 0.5rem;
  color: white;
  background: #605F70;
  width: "100%";
  box-shadow: 0 1px 4px 0 grey;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0px;
  word-wrap: "break-word";
  font-size: ".875rem";
  border-radius: 6px;
  font-family: "Source Sans Pro",sans-serif;
`;
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0rem 0.9rem 0rem 0.9rem;
  font-family: "Source Sans Pro",sans-serif;
`;
const CardTitle = styled.h3`
  margin-top: 0.7rem;
  font-size: 1.1rem;
  font-weight: 500;
  font-family: "Source Sans Pro",sans-serif;
`;
const CardSubTitle = styled.button`
  background-color: white;
  border: 0px;
  margin-top: 0.4rem;
  font-size: 1.1rem;
  font-weight: 400;
  color: #3eb462;
`;
const Data = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
`;
const DataResultGreen = styled.div`
  margin-left: auto;
  padding: 0.25rem 1rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  color: #91C73C;
`;
const DataResultRed = styled.div`
  margin-left: auto;
  padding: 0.25rem 1rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  color: #C53F3F;
`;
const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
`;
const IconResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
`;

const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;

const navLinkStyle = {
  color: '#ffffff',
}

function CustomCardEvolution(props) {
  return (
    <div>
      <Card>
        <TitleContainer>
          <CardTitle>{props.cardTitle}</CardTitle>
        </TitleContainer>
        <DataList>
          <DataContainer>
            <Data>{props.dataName1} : </Data>
            <DataResult>
              {props.data1result ?
                <NumericFormat value={props.data1result} prefix={(props.data1result > 0) ? '+' : ''} displayType={'text'} thousandSeparator={' '} decimalSeparator={','} suffix={'%'} decimalScale={2} />
                : <></>}
            </DataResult>
            <IconResult>
              {(props.data1result > 0) ?
                <Warning /> : <div></div>
              }
            </IconResult>
          </DataContainer>
          <DataContainer>
            <Data>{props.dataName2} : </Data>
            <DataResult>
              {props.data1result ?
                <NumericFormat value={props.data2result} prefix={(props.data2result > 0) ? '+' : ''} displayType={'text'} thousandSeparator={' '} decimalSeparator={','} suffix={'%'} decimalScale={2} />
                : <></>}
            </DataResult>
            <IconResult>
              {(props.data2result > 0) ?
                <Warning /> : <div></div>
              }
            </IconResult>
          </DataContainer>
          {/* <DataContainer>
            <Data>{props.dataName3} : </Data>
            <DataResult>
              {props.data1result ?
                <NumericFormat value={props.data3result} prefix={(props.data3result > 0) ? '+' : ''} displayType={'text'} thousandSeparator={' '} decimalSeparator={','} suffix={'%'} decimalScale={2} />
                : <></>}
            </DataResult>
            <IconResult>
              {(props.data3result > 0) ?
                <Warning /> : <div></div>
              }
            </IconResult>
          </DataContainer>
          <DataContainer>
            <Data>{props.dataName4} : </Data>
            <DataResult>
              {props.data1result ?
                <NumericFormat value={props.data4result} prefix={(props.data4result > 0) ? '+' : ''} displayType={'text'} thousandSeparator={' '} decimalSeparator={','} suffix={'%'} decimalScale={2} />
                : <></>}
            </DataResult>
            <IconResult>
              {(props.data4result > 0) ?
                <Warning /> : <div></div>
              }
            </IconResult> 
          </DataContainer>*/}
        </DataList>
      </Card>
    </div>
  );
}

CustomCardEvolution.propTypes = {
  cardTitle: PropTypes.string,
  dataName1: PropTypes.string,
  data1result: PropTypes.number,
  dataName2: PropTypes.string,
  data2result: PropTypes.number,
  dataName3: PropTypes.string,
  data3result: PropTypes.number,
  dataName4: PropTypes.string,
  data4result: PropTypes.number,
};

export default CustomCardEvolution;
